import {mapFilters} from "@/utils/helpers";

const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {
}
function handleFileDownload(response) {
  if (!response) return;

  const contentDispositionHeader = response.headers['content-disposition'];
  const contentType = response.headers['content-type'];

  if (contentDispositionHeader && contentType) {
    const fullNameMatch = contentDispositionHeader.match(/filename\*=(.+)$/);
    let fullName = fullNameMatch ? fullNameMatch[1] : null;
    if (fullName) {
      fullName = decodeURIComponent(fullName.replace("UTF-8''", ''));
    }

    const file = new File([response.data], fullName, { type: contentType });

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(file);
    downloadLink.download = fullName;

    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}

export const actions = {
  async exportCustomerEvents({ commit }, { filters, pagingInfo }) {
    try {
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      const response = await this.$axios.post(`webpos/export/customer-events`, filter, { responseType: 'blob' });
      handleFileDownload(response);
    } catch (e) {
      this.$toast.error("Error while exporting customer events");
    }
  },

  async exportSalesByItemsReport({ commit }, { filters, pagingInfo }) {
    try {
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      const response = await this.$axios.post(`webpos/export/sales-by-items`, filter, { responseType: 'blob' });
      handleFileDownload(response);
    } catch (e) {
      this.$toast.error("Error while exporting sales by items report");
    }
  },

  async exportIncentiveReport({}, { filters }) {
    try {
      const response = await this.$axios.post(`webpos/export/incentive-report`, filters, { responseType: 'blob' });
      handleFileDownload(response);
    } catch (e) {
      this.$toast.error("Error while exporting incentive report");
    }
  },
};
